import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class PurchaseOrders_ds_inbound_order_transfer_outstanding_order_lines_gridService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }


  public async getList($inParams: { order_id?: number, $top?: number, $skip?: number }): Promise<{ result?: { id?: number, lineNumber?: number, status?: string, material?: string, quantity?: number, available?: number, packaging?: number, lotId?: number, vendorLotId?: number, description?: string, materialId?: number, shipmentId?: number }[], totalCount?: number }> {
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getByKeys($inParams: { order_id?: number, $keys: number[] }): Promise<{ result?: { id?: number, lineNumber?: number, status?: string, material?: string, quantity?: number, available?: number, packaging?: number, lotId?: number, vendorLotId?: number, description?: string, materialId?: number, shipmentId?: number }[] }> {
    const $missingRequiredInParams = [];
    if (isNil($inParams.$keys)) {
      $missingRequiredInParams.push('\'$keys\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

    
    hasMissingRequiredInParams($inParams: { 
      order_id?: number    }) {
      return false;
    }
}
